/* ============================================================
   Southern Pride of Texas — Theme JS
   ============================================================ */

(function () {
  'use strict';

  /* ─── PREDICTIVE SEARCH ─── */
  function initPredictiveSearch() {
    var input = document.getElementById('sp-search-input');
    var dropdown = document.getElementById('sp-search-dropdown');
    // Move dropdown to <body> so it escapes any header stacking context
    // and z-index: 99999 is guaranteed to work
    if (dropdown && dropdown.parentElement !== document.body) {
      document.body.appendChild(dropdown);
    }
    var tabBtns = document.querySelectorAll('.sp-pdrop-tab');
    var productsPanel = document.getElementById('sp-search-results-products');
    var articlesPanel = document.getElementById('sp-search-results-articles');
    var noResults = document.getElementById('sp-search-no-results');
    var viewAll = document.getElementById('sp-search-view-all');
    var suggestionsEl = document.getElementById('sp-search-suggestions');
    if (!input || !dropdown) return;

    /* The drawer's search field drives THIS SAME panel — same doSearch(), same
       suggest.json call, same debounce, same renderProducts() (so the status badge and
       the replacement link come from the one implementation). The only difference is
       where the panel is anchored and the --mobile layout class; there is deliberately
       no second search implementation to keep in step. */
    var mobileInput = document.getElementById('sp-mobile-search-input');

    var debounceTimer;
    var lastQuery = '';
    /* Which field last drove the panel. positionDropdown() reads this to decide anchoring
       and the --mobile class, so the panel follows the input the shopper is actually using
       rather than the viewport width. */
    var activeInput = input;

    function formatSuggestPrice(price) {
      // /search/suggest.json returns price as decimal string e.g. "17.99", not cents
      if (!price) return '';
      var num = parseFloat(price);
      return isNaN(num) ? '' : '$' + num.toFixed(2);
    }

    function positionDropdown() {
      var wrap = document.getElementById('sp-search-wrap');
      var nav = document.querySelector('.sp-nav-bar');
      var isMobile = window.innerWidth <= 900;

      /* Drawer-sourced: anchor under the drawer's search row and switch on the --mobile
         layout class. Toggled HERE, off activeInput — never off a media query — so the
         desktop dropdown cannot pick the class up at any width. */
      var fromDrawer = !!mobileInput && activeInput === mobileInput;
      dropdown.classList.toggle('sp-search-dropdown--mobile', fromDrawer);
      if (fromDrawer) {
        var mw = document.getElementById('sp-mobile-search-wrap') || mobileInput;
        var mr = mw.getBoundingClientRect();
        dropdown.style.top = mr.bottom + 'px';
        dropdown.style.left = '0';
        dropdown.style.width = '100vw';
        dropdown.style.transform = 'none';
        dropdown.style.maxWidth = '100vw';
        /* Sized off visualViewport, NOT innerHeight. innerHeight does not shrink when the
           on-screen keyboard opens, so a panel measured against it runs underneath the
           keyboard and the results the shopper is typing toward are the ones they cannot
           see. visualViewport is what actually reports the usable area. */
        var vh = (window.visualViewport && window.visualViewport.height) || window.innerHeight;
        dropdown.style.maxHeight = Math.max(180, vh - mr.bottom - 8) + 'px';
        return;
      }
      dropdown.style.maxHeight = '';

      if (!isMobile && wrap) {
        // Desktop: anchor to the search bar exactly
        var rect = wrap.getBoundingClientRect();
        dropdown.style.top = rect.bottom + 'px';
        dropdown.style.left = rect.left + 'px';
        dropdown.style.width = Math.max(rect.width, 900) + 'px';
        dropdown.style.transform = 'none';
        dropdown.style.maxWidth = 'calc(100vw - ' + Math.round(rect.left) + 'px - 16px)';
      } else if (nav) {
        // Mobile: anchor below the full-width nav bar
        var navRect = nav.getBoundingClientRect();
        dropdown.style.top = navRect.bottom + 'px';
        dropdown.style.left = '0';
        dropdown.style.width = '100vw';
        dropdown.style.transform = 'none';
        dropdown.style.maxWidth = '100vw';
      }
    }

    function showTab(tab) {
      tabBtns.forEach(function(b) { b.classList.toggle('active', b.dataset.tab === tab); });
      productsPanel.style.display = tab === 'products' ? 'block' : 'none';
      articlesPanel.style.display = tab === 'articles' ? 'block' : 'none';
    }

    tabBtns.forEach(function(btn) {
      btn.addEventListener('click', function() { showTab(btn.dataset.tab); });
    });

    function renderProducts(items) {
      productsPanel.innerHTML = items.slice(0, 8).map(function(p) {
        var img = p.image ? '<img class="sp-search-result-img" src="' + p.image + '" alt="">' : '<div class="sp-search-result-img-placeholder"></div>';
        var price = p.price ? '<div class="sp-search-result-price">' + formatSuggestPrice(p.price) + '</div>' : '';
        var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
        // Freight units must never offer a quick-add here. suggest.json carries `tags` but not
        // metafields, so the 'Call To Order' tag Hub mirrors alongside custom.call_to_order is the
        // only signal available on this surface. Server-side the add would be refused anyway; this
        // is so the shopper gets the phone number instead of a failed button.
        var isCallToOrder = (p.tags || []).indexOf('Call To Order') !== -1;
        var atcBtn = isCallToOrder
          ? '<a class="sp-search-result-atc" href="tel:+14098868626" aria-label="Call to order" data-call-to-order style="text-decoration:none;display:flex;align-items:center;justify-content:center;">&#9742;</a>'
          : (variantId
            ? '<button type="button" class="sp-search-result-atc" data-quick-add="' + variantId + '" data-variant-id="' + variantId + '" aria-label="Add to cart">+</button>'
            : '');
        // Status pill — tag-driven so it works in predictive search (suggest.json exposes
        // `tags` but NOT metafields). Discontinued and Backorder each carry a product tag
        // (Hub mirrors the custom.discontinued / custom.backorder flags to tags on push).
        // Precedence matches everywhere else: discontinued > backorder > in stock.
        var pTags = p.tags || [];
        var statusBadge;
        var replLink = '';
        if (pTags.indexOf('Discontinued') !== -1) {
          statusBadge = '<span class="sp-search-result-badge sp-search-result-badge--disc">Discontinued</span>';
          // The results page and collection cards read custom.replacement_url for this link, but
          // suggest.json's schema has no metafields — so Hub mirrors the replacement's handle into a
          // `replacement-handle:<handle>` tag, the one field in that schema we control. Absent tag =
          // no successor configured = render nothing, matching the blank-metafield contract there.
          for (var t = 0; t < pTags.length; t++) {
            if (pTags[t].indexOf('replacement-handle:') === 0) {
              var replHandle = pTags[t].slice('replacement-handle:'.length);
              if (replHandle) {
                // Root-relative on purpose: keeps the shopper on the public storefront domain they
                // are already on, and can never leak the myshopify host.
                replLink = '<a class="sp-repl-link" href="/products/' +
                  encodeURIComponent(replHandle) + '">View replacement &rarr;</a>';
              }
              break;
            }
          }
        } else if (pTags.indexOf('Backorder') !== -1) {
          statusBadge = '<span class="sp-search-result-badge sp-search-result-badge--backorder">Back Order</span>';
        } else if (pTags.indexOf('Lead Time') !== -1) {
          statusBadge = '<span class="sp-search-result-badge sp-search-result-badge--lead">2–3 Week Lead</span>';
        } else {
          statusBadge = '<span class="sp-search-result-badge sp-search-result-badge--instock">In Stock</span>';
        }
        // The card wrapper is a DIV covered by a transparent stretched <a>, not an <a> itself.
        // That is what lets the replacement link sit inline beside the badge: the badge is
        // inside the card's clickable area, and an <a> nested in an <a> is invalid HTML that
        // the browser silently unnests. The whole-card click target is unchanged.
        return '<div class="sp-search-result-wrap">' +
          '<div class="sp-search-result sp-card-stretch">' +
            '<a class="sp-stretch-link" href="' + p.url + '" aria-label="' +
              String(p.title || '').replace(/"/g, '&quot;') + '"></a>' +
            img +
            '<div class="sp-search-result-info">' +
              '<div class="sp-search-result-title">' + p.title + '</div>' +
              '<div class="sp-search-result-type">Product</div>' +
              '<div class="sp-status-row">' + statusBadge + replLink + '</div>' +
            '</div>' +
            price +
          '</div>' +
          atcBtn +
        '</div>';
      }).join('');
    }

    function renderArticles(items) {
      articlesPanel.innerHTML = items.slice(0, 6).map(function(a) {
        var img = a.image ? '<img class="sp-search-result-img" src="' + a.image + '" alt="">' : '<div class="sp-search-result-img-placeholder"></div>';
        return '<a href="' + a.url + '" class="sp-search-result">' + img + '<div class="sp-search-result-info"><div class="sp-search-result-title">' + a.title + '</div><div class="sp-search-result-type">' + (a.object_type || 'Article') + '</div></div></a>';
      }).join('');
    }

    function renderSuggestions(q) {
      if (!suggestionsEl) return;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=query&resources[limit]=5')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var queries = (data.resources && data.resources.results && data.resources.results.queries) || [];
          if (!queries.length) {
            suggestionsEl.innerHTML = '';
            return;
          }
          suggestionsEl.innerHTML = queries.map(function(s) {
            return '<a href="/search?q=' + encodeURIComponent(s.text) + '" class="sp-search-suggestion">' + s.styled_text + '</a>';
          }).join('');
        }).catch(function() {});
    }

    function doSearch(q) {
      if (!q || q.length < 2) { dropdown.style.display = 'none'; return; }
      if (q === lastQuery) return;
      lastQuery = q;
      viewAll.href = '/search?q=' + encodeURIComponent(q);
      renderSuggestions(q);

      /* ── Extract model numbers from the query ── */
      /* Mirrors the canonical codes in the Hub model registry (spot_models). Longer prefixes come
         first so SPK-/SPX- are not eaten by the SP- branch. Added since the registry landed:
         UXR-100, the BBR-79-SE trim, and the Rolltisserie line (a model with no digits, which the
         old digit-shaped patterns could never match). The compound BBR-79-2/3 is deliberately
         absent — it is expanded into BBR-79-2 + BBR-79-3 at the source and no longer tagged. */
      var modelRegex = /\b(SC-\d+|MLR-\d+(?:-M)?|SPX-\d+(?:-M)?|SRG-\d+|SPK-\d+(?:-M)?|SP-\d+(?:-M)?|BBR-\d+(?:-\d+)?(?:-SE)?|XLR-\d+(?:-\d+)?|DH-\d+|BMJ-\d+[iE]?|OT-\d+|UXR-\d+|YK-\d+[A-Z]?|Rolltisserie)\b/gi;
      var modelMatches = q.match(modelRegex) || [];

      /* ── Build a Shopify tag: query to find products tagged with matched models ──
         e.g. "spk-500 overlay" → "overlay tag:SPK-500"
         Shopify supports tag: prefix in search queries                            */
      var tagQuery = null;
      if (modelMatches.length) {
        var nonModelWords = q.replace(modelRegex, '').replace(/\s+/g, ' ').trim();
        var tagParts = modelMatches.map(function(m) { return 'tag:' + m.toUpperCase(); });
        tagQuery = (nonModelWords ? nonModelWords + ' ' : '') + tagParts.join(' ');
      }

      /* ── Run main search + tag-boosted search in parallel ──
         The main query gets an explicit trailing `*` on its last term. Shopify documents
         prefix=last as the default, but measured 2026-09-10 on this store a bare six-digit
         SKU only found its own product 25/40 times (e.g. 582019 → returned 582011 only,
         typo-tolerance neighbour, exact product absent); the same SKU with a trailing `*`
         found it 40/40. Word queries were unchanged or improved (SPK-500* puts SPK-500-titled
         parts first). Guarded to ≥3-char last terms — a 2-char prefix drifts to the smokers. */
      var lastTerm = q.split(/\s+/).pop();
      var sq = (/[a-z0-9]$/i.test(q) && lastTerm.length >= 3) ? q + '*' : q;
      var mainFetch = fetch(
        '/search/suggest.json?q=' + encodeURIComponent(sq) +
        '&resources[type]=product,article,page&resources[limit]=10' +
        '&resources[options][fields]=title,product_type,variants.sku,variants.title,vendor,tag'
      ).then(function(r) { return r.json(); });

      var tagFetch = tagQuery
        ? fetch(
            '/search/suggest.json?q=' + encodeURIComponent(tagQuery) +
            '&resources[type]=product&resources[limit]=10'
          ).then(function(r) { return r.json(); }).catch(function() { return null; })
        : Promise.resolve(null);

      Promise.all([mainFetch, tagFetch])
        .then(function(results) {
          var mainData = results[0];
          var tagData  = results[1];

          var resources    = mainData.resources && mainData.resources.results;
          var mainProducts = (resources && resources.products) || [];
          var articles     = ((resources && resources.articles) || []).concat((resources && resources.pages) || []);
          var tagProducts  = (tagData && tagData.resources && tagData.resources.results && tagData.resources.results.products) || [];

          /* ── Score & merge ── */
          var seenIds = {};
          var scored  = [];
          var qWords  = q.toLowerCase().split(/\s+/).filter(Boolean);

          var qLower = q.toLowerCase();
          function scoreProduct(p, baseScore) {
            var score = baseScore;
            var titleLower = (p.title || '').toLowerCase();
            var handle     = (p.handle || '').toLowerCase();
            // Exact SKU / title-prefix match always renders first. suggest.json returns
            // `variants: []`, so the SKU is read off the handle (bare SKU or SKU-slug on this
            // catalogue) and the title, which leads with the SKU. Outranks every other boost.
            if (handle === qLower || handle.indexOf(qLower + '-') === 0 || titleLower.indexOf(qLower) === 0) score += 50;
            // Boost if model number appears in title
            modelMatches.forEach(function(m) {
              if (titleLower.indexOf(m.toLowerCase()) !== -1) score += 5;
            });
            // Boost if ALL query words appear in title
            if (qWords.every(function(w) { return titleLower.indexOf(w) !== -1; })) score += 4;
            // Boost per query word in title
            qWords.forEach(function(w) { if (titleLower.indexOf(w) !== -1) score += 1; });
            return score;
          }

          // Add main results (position = high base score)
          mainProducts.forEach(function(p, i) {
            var key = p.id || p.url;
            var score = scoreProduct(p, 15 - i * 0.6);
            seenIds[key] = scored.length;
            scored.push({ product: p, score: score });
          });

          // Merge tag results — if already seen, boost; if new, add with high score
          tagProducts.forEach(function(p) {
            var key = p.id || p.url;
            if (seenIds[key] !== undefined) {
              // Product appears in BOTH searches → large boost (tag match confirmed)
              scored[seenIds[key]].score += 9;
            } else {
              // New product found only via tag search
              var score = scoreProduct(p, 9);
              seenIds[key] = scored.length;
              scored.push({ product: p, score: score });
            }
          });

          // Sort by score descending
          scored.sort(function(a, b) { return b.score - a.score; });
          var products = scored.map(function(s) { return s.product; });

          renderProducts(products);
          renderArticles(articles);
          var hasProducts = products.length > 0;
          var hasArticles = articles.length > 0;
          noResults.style.display = (!hasProducts && !hasArticles) ? 'block' : 'none';
          if (hasProducts) showTab('products');
          else if (hasArticles) showTab('articles');
          positionDropdown();
          dropdown.style.display = 'flex';
        })
        .catch(function() { dropdown.style.display = 'none'; });
    }

    /* Both fields get the SAME handlers. Called once for the header input and once for the
       drawer input; there is no mobile-specific search code path below this point. */
    function bindInput(el) {
      if (!el) return;

      /* Hand the panel to whichever field is being used, and drop the dedupe guard when it
         changes hands. doSearch() early-returns on `q === lastQuery`, so without this a
         shopper who typed 432004 in the header, opened the drawer and typed 432004 again
         would get no panel at all — the query is unchanged, only the driving input moved. */
      function claim() {
        if (activeInput !== el) { activeInput = el; lastQuery = ''; }
      }

      el.addEventListener('input', function() {
        clearTimeout(debounceTimer);
        claim();
        var q = el.value.trim();
        if (!q) { dropdown.style.display = 'none'; lastQuery = ''; return; }
        debounceTimer = setTimeout(function() { doSearch(q); }, 200);
      });

      el.addEventListener('focus', function() {
        claim();
        if (el.value.trim().length >= 2) {
          positionDropdown();
          dropdown.style.display = 'flex';
          if (el !== mobileInput) {
            var nav = document.querySelector('.sp-nav-bar');
            if (nav) nav.style.zIndex = '1';
          }
        }
      });

      el.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          dropdown.style.display = 'none';
          var nav = document.querySelector('.sp-nav-bar');
          if (nav) nav.style.zIndex = '';
        }
      });
    }
    bindInput(input);
    bindInput(mobileInput);

    [document.getElementById('sp-search-form'),
     document.getElementById('sp-mobile-search-form')].forEach(function(f) {
      if (f) f.addEventListener('submit', function() { dropdown.style.display = 'none'; });
    });

    document.addEventListener('click', function(e) {
      /* Clicking inside EITHER search field's wrapper keeps the panel open. The drawer
         wrapper has to be listed too, or the tap that focuses the drawer input would be
         the same tap that closes the panel it just opened. */
      var inside = dropdown.contains(e.target);
      ['sp-search-wrap', 'sp-mobile-search-wrap'].forEach(function(id) {
        var w = document.getElementById(id);
        if (w && w.contains(e.target)) inside = true;
      });
      if (!inside) {
        dropdown.style.display = 'none';
        var nav = document.querySelector('.sp-nav-bar');
        if (nav) nav.style.zIndex = '';
      }
    });

    window.addEventListener('resize', function() {
      if (dropdown.style.display !== 'none') positionDropdown();
    });

    // Reposition on scroll so dropdown stays anchored to header
    window.addEventListener('scroll', function () {
      if (dropdown.style.display !== 'none') positionDropdown();
    }, { passive: true });

    function reposition() { if (dropdown.style.display !== 'none') positionDropdown(); }

    /* The keyboard opening does NOT fire a window resize on mobile Safari — only
       visualViewport reports it. Without these two the panel keeps its pre-keyboard height
       and its bottom rows sit under the keyboard. */
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', reposition);
      window.visualViewport.addEventListener('scroll', reposition);
    }
    /* The drawer scrolls independently of the window, so the window scroll listener above
       never fires for it and the panel would detach from its search row. */
    var drawer = document.getElementById('sp-mobile-menu');
    if (drawer) drawer.addEventListener('scroll', reposition, { passive: true });

    function hideDropdown() {
      dropdown.style.display = 'none';
      var nav = document.querySelector('.sp-nav-bar');
      if (nav) nav.style.zIndex = '';
    }

    /* Watch the drawer's OWN class rather than calling or patching spMobileMenuClose(): the
       close button, the overlay tap and the Escape handler all end at the same class change,
       so observing the RESULT covers every route. That also keeps this file from depending on
       spMobileMenuClose(), which is defined in sections/header.liquid and not here. The panel
       lives on <body>, so closing the drawer would otherwise leave it floating over the page. */
    if (drawer && window.MutationObserver) {
      var wasOpen = drawer.classList.contains('is-open');
      new MutationObserver(function () {
        var isOpen = drawer.classList.contains('is-open');
        if (wasOpen && !isOpen) hideDropdown();
        wasOpen = isOpen;
      }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }

    // Back/forward within the SPA-ish history should not leave a stale panel open.
    window.addEventListener('popstate', hideDropdown);
  }

  /* ─── DRAWER UPSELL PRODUCTS ─── */
  function initDrawerUpsell() {
    var track = document.getElementById('sp-drawer-upsell-products');
    if (!track) return;
    var loaded = false;

    function loadUpsellProducts() {
      if (loaded) return;
      loaded = true;
      fetch('/collections/seasonings-sauces/products.json?limit=8')
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = data.products;
          if (!products || products.length === 0) {
            track.closest('.sp-drawer-upsell').style.display = 'none';
            return;
          }
          track.innerHTML = '';
          products.forEach(function(p) {
            var img = p.images && p.images[0] ? p.images[0].src : null;
            // products.json gives price as a DECIMAL STRING ("15.58"), not cents.
            // Passing it to a cents formatter divided it by 100 a second time and
            // printed $0.16 for a $15.58 shaker. See formatMoneyFromDecimal.
            var price = p.variants && p.variants[0] ? formatMoneyFromDecimal(p.variants[0].price) : '';
            var variantId = p.variants && p.variants[0] ? p.variants[0].id : null;
            var card = document.createElement('div');
            var product_handle = '/products/' + p.handle;
            card.className = 'sp-drawer-upsell-card';
            card.innerHTML =
              (img ? '<img class="sp-drawer-upsell-card-img" src="' + img + '" alt="' + escHtml(p.title) + '">' :
                     '<div class="sp-drawer-upsell-card-img-placeholder"><svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/></svg></div>') +
              '<div class="sp-drawer-upsell-card-body">' +
                '<div class="sp-drawer-upsell-card-title" href="' + product_handle + '">' + escHtml(p.title) + '</div>' +
                '<div class="sp-drawer-upsell-card-price">' + price + '</div>' +
                (variantId ? '<button class="sp-drawer-upsell-card-btn" data-variant-id="' + variantId + '">+ Add</button>' : '') +
              '</div>';
            // clicking card goes to product
            card.querySelector('.sp-drawer-upsell-card-body').addEventListener('click', function(e) {
              if (e.target.tagName === 'BUTTON') return;
              window.location.href = '/products/' + p.handle;
            });
            // add to cart button
            var btn = card.querySelector('.sp-drawer-upsell-card-btn');
            if (btn) {
              btn.addEventListener('click', function(e) {
                e.stopPropagation();
                btn.textContent = '...';
                btn.disabled = true;
                fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({ id: variantId, quantity: 1 })
                }).then(function() {
                  btn.textContent = 'Added';
                  refreshCart();
                  setTimeout(function() {
                    btn.textContent = '+ Add';
                    btn.disabled = false;
                  }, 2000);
                }).catch(function() {
                  btn.textContent = '+ Add';
                  btn.disabled = false;
                });
              });
            }
            track.appendChild(card);
          });
        })
        .catch(function() {
          track.closest('.sp-drawer-upsell').style.display = 'none';
        });
    }

    function escHtml(str) {
      return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }

    // Load when drawer opens
    var drawer = document.getElementById('sp-cart-drawer');
    if (drawer) {
      var observer = new MutationObserver(function(muts) {
        muts.forEach(function(m) {
          if (m.type === 'attributes' && drawer.classList.contains('open')) {
            loadUpsellProducts();
          }
        });
      });
      observer.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* ─── THEME TOGGLE ─── */
  function initThemeToggle() {
    const saved = localStorage.getItem('sp-theme');
    if (saved === 'dark') {
      document.documentElement.classList.add('sp-dark');
      updateToggleIcons(false);
    } else {
      updateToggleIcons(true);
    }
  }

  function updateToggleIcons(isLight) {
    document.querySelectorAll('.sp-toggle-thumb').forEach(function (el) {
      el.textContent = isLight ? 'Day' : 'Night';
    });
  }

  window.spToggleTheme = function () {
    const isDark = document.documentElement.classList.toggle('sp-dark');
    localStorage.setItem('sp-theme', isDark ? 'dark' : 'light');
    updateToggleIcons(!isDark);
  };

  /* ─── CART DRAWER ─── */
  function initCartDrawer() {
    const drawer = document.getElementById('sp-cart-drawer');
    const overlay = document.getElementById('sp-cart-overlay');
    if (!drawer) return;

    function openCart() {
      drawer.classList.add('open');
      drawer.removeAttribute('inert');
      drawer.setAttribute('aria-hidden', 'false');
      overlay.classList.add('open');
      document.body.style.overflow = 'hidden';
      var c = drawer.querySelector('[data-cart-close]');
      if (c) c.focus();
      fetchCart();
    }

    function closeCart() {
      /* return focus before inert yanks it to <body> */
      if (drawer.contains(document.activeElement)) {
        var t = document.querySelector('[data-cart-trigger]');
        if (t) t.focus();
      }
      drawer.classList.remove('open');
      drawer.setAttribute('inert', '');
      drawer.setAttribute('aria-hidden', 'true');
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }

    document.querySelectorAll('[data-cart-trigger]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        openCart();
      });
    });

    overlay.addEventListener('click', closeCart);
    document.querySelectorAll('[data-cart-close]').forEach(function (el) {
      el.addEventListener('click', closeCart);
    });

    window.spOpenCart = openCart;
    window.spCloseCart = closeCart;
  }

  function fetchCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); })
      .catch(function () {});
  }

  function renderCart(cart) {
    const itemsEl = document.getElementById('sp-cart-items');
    const countEls = document.querySelectorAll('.sp-cart-count');
    const subtotalEl = document.getElementById('sp-cart-subtotal');
    if (!itemsEl) return;

    countEls.forEach(function (el) {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? 'flex' : 'none';
    });

    if (subtotalEl) {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="sp-cart-empty"><div class="sp-cart-empty-icon"><svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg></div><p>Your cart is empty.</p></div>';
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (item) {
      return '<div class="sp-cart-item" data-key="' + item.key + '">' +
        '<a href="' + item.url + '" class="sp-cart-item-img">' +
          (item.image ? '<img src="' + item.image + '" alt="' + item.product_title + '">' : '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="3" width="18" height="18" rx="2"/></svg>') +
        '</a>' +
        '<div class="sp-cart-item-info">' +
          '<div class="sp-cart-item-title">' + item.product_title + '</div>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="sp-cart-item-variant">' + item.variant_title + '</div>' : '') +
          '<div class="sp-cart-item-price">' + formatMoney(item.final_line_price) + '</div>' +
          '<div class="sp-cart-item-qty-row">' +
            '<button class="sp-cart-qty-btn sp-cart-qty-dec" data-key="' + item.key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">−</button>' +
            '<span class="sp-cart-qty-val">' + item.quantity + '</span>' +
            '<button class="sp-cart-qty-btn sp-cart-qty-inc" data-key="' + item.key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
          '</div>' +
        '</div>' +
        '<button class="sp-cart-item-remove" data-key="' + item.key + '" aria-label="Remove">' +
          '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>' +
        '</button>' +
      '</div>';
    }).join('');

    // Wire qty buttons and remove buttons via delegation
    function cartChange(key, qty, btn) {
      if (btn) btn.disabled = true;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function(r) { return r.json(); })
        .then(function(cart) { renderCart(cart); })
        .catch(function() { if (btn) btn.disabled = false; });
    }

    itemsEl.querySelectorAll('.sp-cart-qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        cartChange(btn.dataset.key, parseInt(btn.dataset.qty), btn);
      });
    });

    itemsEl.querySelectorAll('.sp-cart-item-remove').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        cartChange(btn.dataset.key, 0, btn);
      });
    });
  }

  /* ─── MONEY: TWO UNITS, TWO FUNCTIONS ───────────────────────────────────
     Shopify's storefront JSON endpoints do not agree on how they express money,
     and reading one with the other's assumption is a silent factor of 100.

       CENTS (integer):   /cart.js            total_price, final_line_price
       DECIMAL (string):  /products.json      variants[].price  ("15.58")
                          /collections/<handle>/products.json
                          /recommendations/products.json
                          /search/suggest.json

     The cart drawer's upsell tiles read the collection products.json and passed
     it to the cents formatter, so $15.58 rendered as $0.16 and a $212.94 case as
     $2.13. Both formatters below are now named for the unit they take, so the
     mistake has to be made out loud.

     Display only — no price is ever posted to /cart/add.js, which sends id and
     quantity and lets Shopify price the line. */

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /** Money that already arrives as a decimal string or number. NEVER divide. */
  function formatMoneyFromDecimal(value) {
    var num = parseFloat(value);
    if (isNaN(num)) return '';
    // Same thousands grouping as formatMoney, so a $1,299 case reads the same
    // way in the drawer tiles as it does on the cart line above them.
    return '$' + num.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ─── ADD TO CART ─── */
  function initAddToCart() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.classList.contains('sp-atc-form')) return;
      e.preventDefault();

      var btn = form.querySelector('[data-atc-btn]');
      if (!btn) return;
      var originalText = btn.innerHTML;
      btn.innerHTML = '<span class="sp-spinner"></span>';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: form.querySelector('[name="id"]').value, quantity: parseInt(form.querySelector('[name="quantity"]').value) || 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.innerHTML = 'Added!';
          btn.style.background = 'var(--sp-success)';
          fetchCart();
          if (window.spOpenCart) window.spOpenCart();
          setTimeout(function () {
            btn.innerHTML = originalText;
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.innerHTML = 'Error — try again';
          btn.style.background = 'var(--sp-error)';
          setTimeout(function () {
            btn.innerHTML = originalText;
            btn.style.background = '';
            btn.disabled = false;
          }, 2000);
        });
    });
  }

  /* ─── QTY STEPPER ─── */
  function initQtyStepper() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty]');
      if (!btn) return;
      var input = btn.closest('.sp-qty-wrap').querySelector('.sp-qty-input');
      if (!input) return;
      var val = parseInt(input.value) || 1;
      if (btn.dataset.qty === 'up') input.value = val + 1;
      if (btn.dataset.qty === 'down' && val > 1) input.value = val - 1;
    });
  }

  /* ─── GALLERY THUMBS ─── */
  function initGallery() {
    document.querySelectorAll('.sp-gallery-thumb').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = this.dataset.src;
        var alt = this.dataset.alt || '';
        var main = document.querySelector('.sp-gallery-main');
        if (!main) return;
        var img = main.querySelector('img');
        if (img) {
          img.src = src;
          img.alt = alt;
        } else {
          main.innerHTML = '<img src="' + src + '" alt="' + alt + '">';
        }
        document.querySelectorAll('.sp-gallery-thumb').forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  }

  /* ─── PRODUCT TABS ─── */
  function initTabs() {
    document.querySelectorAll('.sp-tab-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var target = this.dataset.tab;
        var container = this.closest('.sp-product-tabs');
        container.querySelectorAll('.sp-tab-btn').forEach(function (b) { b.classList.remove('active'); });
        container.querySelectorAll('.sp-tab-panel').forEach(function (p) { p.classList.remove('active'); });
        this.classList.add('active');
        var panel = container.querySelector('[data-panel="' + target + '"]');
        if (panel) panel.classList.add('active');
      });
    });
  }

  /* ─── FILTER TOGGLE ─── */
  function initFilters() {
    document.querySelectorAll('.sp-filter-heading').forEach(function (heading) {
      heading.addEventListener('click', function () {
        var body = this.nextElementSibling;
        var chevron = this.querySelector('.sp-filter-chevron');
        if (body) body.style.display = body.style.display === 'none' ? '' : 'none';
        if (chevron) chevron.textContent = body.style.display === 'none' ? '▶' : '▼';
      });
    });
  }

  /* ─── STICKY NAV SHADOW ─── */
  function initStickyNav() {
    var nav = document.querySelector('.sp-nav-bar');
    if (!nav) return;
    window.addEventListener('scroll', function () {
      nav.style.boxShadow = window.scrollY > 20 ? '0 2px 30px rgba(0,0,0,0.6)' : '0 2px 20px rgba(0,0,0,0.4)';
    });
  }

  /* ─── COLLECTION QUICK-ADD ─── */
  /* Intercepts any [data-quick-add] button on collection/listing pages */
  function initCollectionQuickAdd() {
    function handleQuickAdd(e) {
      var btn = e.target.closest('[data-quick-add]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.cancelable) e.preventDefault();

      var variantId = btn.dataset.variantId || btn.dataset.quickAdd;
      if (!variantId) return;

      var originalText = btn.textContent;
      btn.textContent = '...';
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.textContent = 'Added!';
          fetchCart();
          if (window.spOpenCart) window.spOpenCart();
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        })
        .catch(function () {
          btn.textContent = 'Error';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 2000);
        });
    }
    document.addEventListener('click', handleQuickAdd);
    document.addEventListener('touchend', handleQuickAdd);
  }

  /* ─── INIT ─── */
  document.addEventListener('DOMContentLoaded', function () {
    initThemeToggle();
    initCartDrawer();
    initDrawerUpsell();
    initPredictiveSearch();
    initAddToCart();
    initCollectionQuickAdd();
    initQtyStepper();
    initGallery();
    initTabs();
    initFilters();
    initStickyNav();
    fetchCart();
    initSearchPageATC();
  });


  /* ─── SEARCH PAGE ATC ─── */
  /* On /search results, product cards link to product page with no ATC button.
     This injects an "Add to Cart" button onto every search result product card. */
  function initSearchPageATC() {
    if (!window.location.pathname.startsWith('/search')) return;

    // Shopify search result cards use class "card-wrapper" or similar.
    // We find product links and inject a button after each.
    var cards = document.querySelectorAll(
      '.card-wrapper, .product-card-wrapper, [class*="product-card"], .grid__item'
    );

    cards.forEach(function(card) {
      // Skip if already has a quick-add button
      if (card.querySelector('[data-quick-add]')) return;
      // Skip freight/call-to-order cards outright — this injector reads a variant id straight out
      // of the card markup, so without this it would re-create the very button the Liquid removed.
      if (card.querySelector('[data-call-to-order]')) return;

      // Find the product URL from any link in the card
      var link = card.querySelector('a[href*="/products/"]');
      if (!link) return;

      // Try to find variant ID from a form[action="/cart/add"] or data attr in the card
      var form = card.querySelector('form[action="/cart/add"]');
      var variantInput = form && form.querySelector('[name="id"]');
      if (!variantInput) return;

      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'sp-collection-atc';
      btn.dataset.quickAdd = variantInput.value;
      btn.dataset.variantId = variantInput.value;
      btn.textContent = 'Add to Cart';

      // Insert after the card's product info / at the bottom of the card
      card.appendChild(btn);
    });
  }

  /* ─── MOBILE MENU ───
     spMobileMenuOpen / spMobileMenuClose / spMobileAccordion, and the Escape-to-close
     listener, are DELIBERATELY NOT DEFINED HERE. They live once, inline in
     sections/header.liquid, which is the only place that calls them (every caller is an
     onclick= on that section's own markup).

     They used to be defined in BOTH files, byte-for-byte identical, and which copy won was
     decided by load order rather than intent: this asset is loaded with `defer`, so it
     executed last and silently shadowed the inline copy. Keeping the inline one is what
     makes the drawer work during page load — a deferred script does not run until the whole
     document is parsed, so a tap on the hamburger before that point would have thrown
     ReferenceError with the definition only here.

     Anything in this file that needs to react to the drawer must observe its RESULT (see the
     MutationObserver on #sp-mobile-menu's class in initPredictiveSearch) rather than call or
     patch those functions, so it stays correct no matter which file owns them. */


  /* ─── MEGA MENU PANEL SWITCHER ─── */
  function spMegaSwitch(item, megaId) {
    var mega = document.getElementById(megaId);
    if (!mega) return;
    // Hide all panels
    mega.querySelectorAll('.sp-mega-panel').forEach(function(p) { p.style.display = 'none'; });
    // Show target panel
    var panelId = item.getAttribute('data-panel');
    var panel = document.getElementById(panelId);
    if (panel) panel.style.display = 'block';
    // Update active sidebar item within the same mega
    var sidebar = item.closest('.sp-mega-sidebar');
    if (sidebar) {
      sidebar.querySelectorAll('.sp-mega-sidebar-item').forEach(function(i) {
        i.classList.remove('sp-mega-sidebar-item--active');
      });
      item.classList.add('sp-mega-sidebar-item--active');
    }
  }
  window.spMegaSwitch = spMegaSwitch;

})();
